export interface Coordinates {
  readonly lat: number;
  readonly lon: number;
}

export class CoordinatesModel implements Coordinates {
  readonly lat: number;
  readonly lon: number;
  constructor(lat: number, lon: number) {
    this.lat = lat
    this.lon = lon
  }
}